import { Injectable } from '@angular/core';

interface Theme {
  primaryColor?: string;
  primaryForeground?: string;
  secondaryColor?: string;
  accentColor?: string;
  brandLogo?: string;
  backgroundUrl?: string;
  backgroundColor?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private primaryColor = '#005EC1';
  private primaryForeground = 'white';
  private secondaryColor = '#46C1A4';
  private accentColor = '#2F0475';
  private _brandLogo = 'assets/images/ESC 3D-official.png';
  private backgroundUrl = '/assets/images/background-8.png';
  private backgroundColor = 'white';

  private DEFAULT_PRIMARY_COLOR = '#005EC1';
  private DEFAULT_PRIMARY_FOREGROUND = 'white';
  private DEFAULT_SECONDARY_COLOR = '#46C1A4';
  private DEFAULT_ACCENT_COLOR = '#2F0475';
  private DEFAULT_BRAND_LOGO = 'assets/images/ESC 3D-official.png';
  private DEFAULT_BACKGROUND_URL = '/assets/images/background-8.png';
  private DEFAULT_BACKGROUND_COLOR = 'white';

  constructor() {
    this.changeTheme({
      primaryColor: this.primaryColor,
      primaryForeground: this.primaryForeground,
      secondaryColor: this.secondaryColor,
      accentColor: this.accentColor,
      brandLogo: this.brandLogo,
      backgroundUrl: this.backgroundUrl,
      backgroundColor: this.backgroundColor
    });
  }

  get brandLogo() {
    return this._brandLogo;
  }

  public changeTheme(theme: Theme) {
    const primaryColor = theme.primaryColor || this.DEFAULT_PRIMARY_COLOR;
    const primaryForeground =
      theme.primaryForeground || this.DEFAULT_PRIMARY_FOREGROUND;
    const secondaryColor = theme.secondaryColor || this.DEFAULT_SECONDARY_COLOR;
    const accentColor = theme.accentColor || this.DEFAULT_ACCENT_COLOR;
    const brandLogo = theme.brandLogo || this.DEFAULT_BRAND_LOGO;
    const backgroundUrl = theme.backgroundUrl || this.DEFAULT_BACKGROUND_URL;
    const backgroundColor = theme.backgroundColor || this.DEFAULT_BACKGROUND_COLOR;

    document.documentElement.style.setProperty('--primary-color', primaryColor);
    document.documentElement.style.setProperty(
      '--primary-foreground',
      primaryForeground
    );
    document.documentElement.style.setProperty(
      '--secondary-color',
      secondaryColor
    );
    document.documentElement.style.setProperty('--accent-color', accentColor);
    document.documentElement.style.setProperty('--background-color', backgroundColor);

    this.primaryColor = primaryColor;
    this.primaryForeground = primaryForeground;
    this.secondaryColor = secondaryColor;
    this.accentColor = accentColor;
    this._brandLogo = brandLogo;

    const background = document.querySelector('.single-form') as HTMLElement;

    if (background) {
      background.style.backgroundImage = `url(${backgroundUrl})`;
    }
  }

  // dev note: as of now this function uses schema_code parameter to conditionally render the image of mercury drug, since the database does not provide the right image for the client
  buildThemeObject(data: any, schema_code: string) {
    const theme = {
      primaryColor: data.theme.primary_color,
      primaryForeground: data.theme.primary_foreground,
      secondaryColor: data.theme.secondary_color,
      accentColor: data.theme.accent_color,
      brandLogo: schema_code === '02' ? 'https://www.mercurydrug.com/public/images/md-main-logo.png' : data.theme.brand_logo,
      backgroundUrl: data.theme.background_url,
      backgroundColor: data.theme.background_color
    };

    return theme;
  }
}
